import React from 'react'
import styled from 'styled-components'

import { NumberInput } from '../../../../input'
import { FONTS } from '../../../../../constants'
import { formatNumber, toNumber } from '../../../../../function/math'

export const InputRow = React.memo(({
  data,
  index,
  type,
  progressIndex,
  name,
  criteria,
  handleInput,
  isEditing,
}) => {
  const {
    last_percentage,
    current_percentage,
    cost_base_percentage,
    gap_percentage,
    last_revenue,
    current_revenue,
    cost_base_revenue,
    gap_revenue,
  } = data

  return (
    <Root>
      <FirstWrapper>
        <TitleCol>
          <Title>{ criteria === 'MD' ? 'MD' : 'Percentage' }</Title>
        </TitleCol>
        <Row>
          <PercentageCol>
            <Text>{ last_percentage } { criteria === 'MD' ? 'MD' : '%' }</Text>
          </PercentageCol>
        </Row>
        <Row>
          <PercentageCol>
            <NumberInput
              suffix={ criteria === 'MD' ? 'MD' : '%' }
              value={ current_percentage }
              allowEmptyFormatting={ true }
              thousandSeparator={ true }
              decimalScale={ 2 }
              fixedDecimalScale={ true }
              allowNegative={ true }
              disabled={ !isEditing }
              invalid={
                type !== 'SUBSCRIPTION'
                && criteria !== 'MD'
                && name[0] === 'accumulate_percentage'
                && toNumber(current_percentage) > 100
              }
              onChange={ e => handleInput(formatNumber(e.target.value), progressIndex, index, name[0]) }
            />
          </PercentageCol>
        </Row>
        <Row>
          <PercentageCol>
            <Text>{ cost_base_percentage } { criteria === 'MD' ? 'MD' : '%' }</Text>
          </PercentageCol>
        </Row>
        <Row>
          <PercentageCol>
            <Text value={ gap_percentage }>{ gap_percentage } { criteria === 'MD' ? 'MD' : '%' }</Text>
          </PercentageCol>
        </Row>
      </FirstWrapper>
      <SecondWrapper>
        <TitleCol>
          <Title>Revenue</Title>
        </TitleCol>
        <Row>
          <PercentageCol>
            <Text>฿ { last_revenue }</Text>
          </PercentageCol>
        </Row>
        <Row>
          <PercentageCol>
            <NumberInput
              suffix='฿'
              value={ current_revenue }
              allowEmptyFormatting={ true }
              thousandSeparator={ true }
              decimalScale={ 2 }
              fixedDecimalScale={ true }
              allowNegative={ true }
              disabled={ !isEditing }
              onChange={ e => handleInput(formatNumber(e.target.value), progressIndex, index, name[1]) }
            />
          </PercentageCol>
        </Row>
        <Row>
          <PercentageCol>
            <Text>฿ { cost_base_revenue }</Text>
          </PercentageCol>
        </Row>
        <Row>
          <PercentageCol>
            <Text value={ gap_revenue }>฿ { gap_revenue }</Text>
          </PercentageCol>
        </Row>
      </SecondWrapper>
    </Root>
  )
})

const Root = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #F2F2F2;
  border: 1px solid #EAEAEA;
  padding: 6px 18px;
  margin-top: 4px;

  :nth-last-child(1) {
    margin-bottom: 4px;
  }
`

const Row = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 0 16px;
`

const FirstWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`

const SecondWrapper = styled(FirstWrapper)`
  margin-top: 4px;
`

const TitleCol = styled.div`
  width: 80px;
  display: flex;
  align-items: center;
`

const PercentageCol = styled.div`
  height: 100%;
  max-width: 150px;
  display: flex;
  justify-content: flex-end;
`

const Text = styled.span`
  font-family: NotoSans;
  font-size: ${FONTS.SMALL_SIZE};
  color: ${p => {
    if (p.value < 0) return '#D44B49'
    else if (p.value > 0) return '#27AE60'
    return '#333333'
  }};
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #606060;
`



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/PercentTable/item/detail/InputRow.js